import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AddIcon from '@mui/icons-material/Add';
import './styles/SocialHeader.scss';

interface SocialHeaderProps {
    title?: string;
    showBack?: boolean;
    onBack?: () => void;
    onSearch?: () => void;
    onNotifications?: () => void;
    onAdd?: () => void;
}

const SocialHeader: React.FC<SocialHeaderProps> = ({ 
    title = 'Social',
    showBack = false,
    onBack,
    onSearch,
    onNotifications,
    onAdd
}) => {
    const handleBack = () => {
        if (onBack) {
            onBack();
        } else {
            window.history.back();
        }
    };

    return (
        <header className="SocialHeader">
            <div className="Container">
                <div className="Left">
                    {showBack && (
                        <button className="Back" onClick={handleBack}>
                            <ArrowBackIcon />
                        </button>
                    )}
                    <h1 className="Title">{title}</h1>
                </div>
                <div className="Right">
                    {onAdd && (
                        <button className="Action" onClick={onAdd}>
                            <AddIcon />
                        </button>
                    )}
                    {onSearch && (
                        <button className="Action" onClick={onSearch}>
                            <SearchIcon />
                        </button>
                    )}
                    {onNotifications && (
                        <button className="Action" onClick={onNotifications}>
                            <NotificationsIcon />
                        </button>
                    )}
                </div>
            </div>
        </header>
    );
};

export default SocialHeader;